import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const vaTaskApi = createApi({
  reducerPath: "vaTaskApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["VATask"],
  endpoints: (builder) => ({
    getAllVATasks: builder.query({
      query: (params) => ({
        url: "/va-tasks",
        params,
      }),
      transformResponse: (response) => response.data || { tasks: [], stats: {}, assignees: [] },
      providesTags: ["VATask"],
    }),

    createVATask: builder.mutation({
      query: (data) => ({
        url: "/va-tasks",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["VATask"],
    }),

    updateVATask: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/va-tasks/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["VATask"],
    }),

    deleteVATask: builder.mutation({
      query: (id) => ({
        url: `/va-tasks/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["VATask"],
    }),

    bulkUpdateVATasks: builder.mutation({
      query: (data) => ({
        url: "/va-tasks/bulk-update",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["VATask"],
    }),
  }),
});

export const {
  useGetAllVATasksQuery,
  useCreateVATaskMutation,
  useUpdateVATaskMutation,
  useDeleteVATaskMutation,
  useBulkUpdateVATasksMutation,
} = vaTaskApi;
